const prefix = 'LEADS';
// fetch leads
export const GET_LEADS = Symbol(`${prefix}/GET_LEADS`);
export const GET_LEADS_SUCCESS = Symbol(`${prefix}/GET_LEADS_SUCCESS`);
export const GET_LEADS_FAIL = Symbol(`${prefix}/GET_LEADS_FAIL`);
export const GET_SINGLE_LEAD = Symbol(`${prefix}/GET_SINGLE_LEAD`);
export const GET_SINGLE_LEAD_SUCCESS = Symbol(`${prefix}/GET_SINGLE_LEAD_SUCCESS`);
export const GET_SINGLE_LEAD_FAIL = Symbol(`${prefix}/GET_SINGLE_LEAD_FAIL`);
// search leads
export const SEARCH_LEADS = Symbol(`${prefix}/GET_LEADS`);
export const SEARCH_LEADS_SUCCESS = Symbol(`${prefix}/SEARCH_LEADS_SUCCESS`);
export const SEARCH_LEADS_FAIL = Symbol(`${prefix}/SEARCH_LEADS_FAIL`);
// fetch filters
export const GET_LEADS_FILTERS = Symbol(`${prefix}/GET_LEADS_FILTERS`);
export const GET_LEADS_FILTERS_IN_BACKGROUND = Symbol(`${prefix}/GET_LEADS_FILTERS_IN_BACKGROUND`);
export const GET_LEADS_FILTERS_SUCCESS = Symbol(`${prefix}/GET_LEADS_FILTERS_SUCCESS`);
export const GET_LEADS_FILTERS_FAIL = Symbol(`${prefix}/GET_LEADS_FILTERS_FAIL`);
// fetch, create, update, delete custom statuses.
export const GET_LEADS_STATUSES = Symbol(`${prefix}/GET_LEADS_STATUSES`);
export const GET_LEADS_STATUSES_SUCCESS = Symbol(`${prefix}/GET_LEADS_STATUSES_SUCCESS`);
export const CREATE_LEADS_STATUS = Symbol(`${prefix}/CREATE_LEADS_STATUS`);
export const UPDATE_STATUSES_SUCCESS = Symbol(`${prefix}/UPDATE_STATUSES_SUCCESS`);
export const UPDATE_STATUSES_FAIL = Symbol(`${prefix}/UPDATE_STATUSES_FAIL`);
// update lead status in lead table row
export const UPDATE_LEAD_STATUS = Symbol(`${prefix}/UPDATE_LEAD_STATUS`);
export const UPDATE_LEAD_SUCCESS = Symbol(`${prefix}/UPDATE_LEAD_SUCCESS`);
export const UPDATE_LEAD_ERROR = Symbol(`${prefix}/UPDATE_LEAD_ERROR`);
export const UPDATE_LEAD_CANCEL = Symbol(`${prefix}/UPDATE_LEAD_CANCEL`);
// update lead least ocntacted date in lead table row
export const UPDATE_LEAD_LAST_CONTACTED = Symbol(`${prefix}/UPDATE_LEAD_LAST_CONTACTED`);
// delete lead in lead table row
export const DELETE_LEAD_STATUS = Symbol(`${prefix}/DELETE_LEAD_STATUS`);
export const DELETE_LEAD_SUCCESS = Symbol(`${prefix}/DELETE_LEAD_SUCCESS`);
export const DELETE_LEAD_ERROR = Symbol(`${prefix}/DELETE_LEAD_ERROR`);
export const DELETE_LEAD_CANCEL = Symbol(`${prefix}/DELETE_LEAD_CANCEL`);
// lead dropdown preferences
export const UPDATE_LEAD_PREFERENCES = Symbol(`${prefix}/UPDATE_LEAD_PREFERENCES`);
export const GET_LEAD_PREFERENCES = Symbol(`${prefix}/GET_LEAD_PREFERENCES`);
// fetch organization members
export const GET_ORG_MEMBERS = Symbol(`${prefix}/GET_ORG_MEMBERS`);
export const GET_ORG_MEMBERS_SUCCESS = Symbol(`${prefix}/GET_ORG_MEMBERS_SUCCESS`);
export const GET_ORG_MEMBERS_FAIL = Symbol(`${prefix}/GET_ORG_MEMBERS_FAIL`);
// update lead assignments
export const GET_LEAD_ASSIGNMENTS = Symbol(`${prefix}/GET_LEAD_ASSIGNMENTS`);
export const UPDATE_LEAD_ASSIGNMENTS_STATE = Symbol(`${prefix}/UPDATE_LEAD_ASSIGNMENTS_STATE`);
export const CREATE_LEAD_ASSIGNMENT = Symbol(`${prefix}/CREATE_LEAD_ASSIGNMENT`);
export const CREATE_LEAD_ASSIGNMENT_SUCCESS = Symbol(`${prefix}/CREATE_LEAD_ASSIGNMENT_SUCCESS`);
export const CREATE_LEAD_ASSIGNMENT_FAIL = Symbol(`${prefix}/CREATE_LEAD_ASSIGNMENT_FAIL`);
export const DELETE_LEAD_ASSIGNMENT = Symbol(`${prefix}/DELETE_LEAD_ASSIGNMENT`);
export const DELETE_LEAD_ASSIGNMENT_SUCCESS = Symbol(`${prefix}/DELETE_LEAD_ASSIGNMENT_SUCCESS`);
export const DELETE_LEAD_ASSIGNMENT_FAIL = Symbol(`${prefix}/DELETE_LEAD_ASSIGNMENT_FAIL`);

// custom preferences
export const GET_LEAD_CUSTOM_PREFERENCES = Symbol(`${prefix}/GET_LEAD_CUSTOM_PREFERENCES`);
export const ADD_LEAD_CUSTOM_PREFERENCES = Symbol(`${prefix}/ADD_LEAD_CUSTOM_PREFERENCES`);

// duplicate lead
export const DUPLICATE_LEAD = Symbol(`${prefix}/DUPLICATE_LEAD`);
export const DUPLICATE_LEAD_SUCCESS = Symbol(`${prefix}/DUPLICATE_LEAD_SUCCESS`);
export const DUPLICATE_LEAD_FAIL = Symbol(`${prefix}/DUPLICATE_LEAD_FAIL`);
